module.exports = __webpack_public_path__ + "img/consultor-master.8d6ad93a.png";